<template>
  <div>
    <el-row>
      <FuncionalidadeHeader
        v-if="funcData.parametros.textos.esqueciSenhaTituloNavegacao"
        :titulo="funcData.parametros.textos.esqueciSenhaTituloNavegacao"
        :custom-voltar="true"
        :info="false"
        :login="true"
        @click="$emit('voltar')"/>
      <AlertaErro
        v-model="erro.show"
        :title="erro.titulo"
        :description="erro.descricao"
      />
    </el-row>
    <el-main v-if="step == 0">
      <el-row class="text-center">
        <HelperBiometriaSvg/>
      </el-row>
      <el-row style="margin-top: 20px;margin-bottom: 20px" class="text-center">
        <h3>{{ funcData.parametros.textos.recuperarSenhaQuestionarioInicioTitulo }}</h3>
      </el-row>
      <el-row class="text-center">
        <p
          v-if="funcData.parametros.textos.recuperarSenhaQuestionarioInicioTexto"
          class="recuperar-cabecalho">
          {{ funcData.parametros.textos.recuperarSenhaQuestionarioInicioTexto }}
        </p>
      </el-row>
      <el-row>
        <ButtonDefault
          :title="funcData.parametros.textos.recuperarSenhaQuestionarioInicioBotaoIniciarLabel"
          @click="start"
        />
      </el-row>
    </el-main>
    <el-main v-if="step == 1">
      <HorizontalSteps :total-steps="listaQuestoes.length" :current-step="currentStep"/>
      <el-row  style="margin-top: 20px;margin-bottom: 20px">
        <h3>{{ questaoAtual.questao }}</h3>
        <p>{{ questaoAtual.textoAjuda }}</p>
      </el-row>
      <el-row>
        <div v-for="(questao, index) in questaoAtual.alternativas" :key="index" class="answer">
          <input type="radio" :name="questaoAtual.idQuestao" v-bind:id="`answer${index}`" :value="questao.idAlternativa" v-model="selectedAnswer" @change="validateQuestion"/>
          <label v-bind:for="`answer${index}`">{{ questao.resposta }}</label>
        </div>
      </el-row>
      <el-row class="lineActionButtons">
        <el-col v-if="this.indexQuestao>0" >
          <ButtonDefault
            :title="'Anterior'"
            @click="prevQuestions"
            :secundario="true"
          />
        </el-col>
        <el-col v-if="currentStep<listaQuestoes.length">
          <ButtonDefault
            :title="'próximo'"
            @click="nextQuestions"
          />
        </el-col>
        <el-col v-if="currentStep==listaQuestoes.length">
          <ButtonDefault
            :title="'Finalizar'"
            @click="questionsVerification"
          />
        </el-col>
      </el-row>
    </el-main>
    <el-main v-if="step == 2">
      <el-row class="text-center">
        <HelperExclamationSvg/>
      </el-row>
      <el-row class="text-center" style="margin-top: 20px;margin-bottom: 20px">
        <h3>Identidade não validada</h3>
      </el-row>
      <el-row class="text-center" style="margin-bottom: 20px">
        {{ funcData.parametros.textos.recuperarSenhaTextoIdentidadeNaoValidada }}
      </el-row>
      <el-row>
        <ButtonDefault
          :title="funcData.parametros.textos.recuperarSenhaQuestionariolabelTentarNovamente"
          @click="retry"
        />
      </el-row>
    </el-main>

    <ButtonDefault
      v-if="config.configuracaoAcesso.centralDeAjuda.ativo"
      :title="'Central de ajuda'"
      :secundario="true"
    />
  </div>
</template>

<script>
import AlertaErro from '@/components/AlertaError/AlertaErro'
import { mapActions, mapGetters, mapState } from 'vuex'
import FuncionalidadeHeader from '@/components/FuncionalidadeHeader/FuncionalidadeHeader'
import ButtonDefault from '@/components/buttons/ButtonDefault'
import HorizontalSteps from '@/components/MultiSteps/HorizontalSteps'
import HelperBiometriaSvg from '@/components/SVG/HelperBiometria.vue'
import HelperExclamationSvg from '@/components/SVG/HelperExclamation.vue'

export default {
  name: 'RecuperarSenhaQuestionario',
  components: {
    HelperExclamationSvg,
    HelperBiometriaSvg,
    HorizontalSteps,
    FuncionalidadeHeader,
    AlertaErro,
    ButtonDefault
  },
  data () {
    return {
      form: {},
      erro: {
        show: false,
        titulo: 'Erro no preenchimento:',
        descricao: 'Você precisa escolher ao menos uma resposta.'
      },
      step: 0,
      listaQuestoes: [],
      selectedAnswer: null,
      indexQuestao: 0,
      validQuestion: false,
      answerList: {
        idQuestao1: null,
        idAlternativa1: null,
        idQuestao2: null,
        idAlternativa2: null,
        idQuestao3: null,
        idAlternativa3: null
      }
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState('SetupApp', ['config', 'apiAcesso', 'frameId']),
    ...mapGetters('SetupApp', ['estilo']),
    funcData () {
      return this.config.configuracaoAcesso.recuperarSenha
    },
    buttonStyle () {
      return {
        'background-color': this.estilo.aplicacao.corPrimariaAplicacao
      }
    },
    styleSecundario () {
      return {
        'background-color': this.estilo.aplicacao.corSecundariaAplicacao
      }
    },
    questaoAtual () {
      return this.listaQuestoes[this.indexQuestao]
    },
    currentStep () {
      return this.indexQuestao + 1
    }
  },
  methods: {
    ...mapActions('Login', ['setLogin']),
    async init () {
      await this.loadQuestions()
    },
    async loadQuestions () {
      const { status, data: { questionario } } = await this.apiAcesso.recuperarSenha.recuperarSenhaQuestionario({
        loading: true,
        handlerErrorIgnore: true
      })

      if (!status) {
        this.$emit('retry')
        return
      }
      this.listaQuestoes = questionario
    },
    nextQuestions () {
      if (this.validQuestion) {
        this.answerList[`idQuestao${this.currentStep}`] = this.questaoAtual.idQuestao
        this.answerList[`idAlternativa${this.currentStep}`] = this.selectedAnswer
        this.indexQuestao++
        this.selectedAnswer = null
        this.validQuestion = false
        this.erro.show = false
      } else {
        this.showError()
      }
    },
    prevQuestions () {
      this.indexQuestao--
      this.questaoAtual.idQuestao = this.answerList[`idQuestao${this.currentStep}`]
      this.selectedAnswer = this.answerList[`idAlternativa${this.currentStep}`]
      this.validQuestion = true
      this.erro.show = false
    },
    validateQuestion () {
      this.validQuestion = true
      this.erro.show = false
    },
    async questionsVerification () {
      if (this.validQuestion) {
        this.answerList[`idQuestao${this.currentStep}`] = this.questaoAtual.idQuestao
        this.answerList[`idAlternativa${this.currentStep}`] = this.selectedAnswer
        this.selectedAnswer = null
        this.validQuestion = false
        this.erro.show = false

        let payload = {
          idQuestao1: this.answerList.idQuestao1,
          idAlternativa1: this.answerList.idAlternativa1,
          idQuestao2: this.answerList.idQuestao2,
          idAlternativa2: this.answerList.idAlternativa2,
          idQuestao3: this.answerList.idQuestao3,
          idAlternativa3: this.answerList.idAlternativa3
        }
        const { status, data } = await this.apiAcesso.recuperarSenha.recuperarSenhaQuestionarioVerificacao({
          payload,
          loading: true,
          handlerErrorIgnore: true
        })
        if (!status) {
          this.step = 2
          return
        }
        this.$emit('submit', data)
      } else {
        this.showError()
      }
    },
    retry () {
      this.$emit('retry')
    },
    showError () {
      this.erro.show = true
    },
    async start () {
      this.step = 1
    }
  }
}
</script>

<style scoped>
.recuperar-cabecalho {
  letter-spacing: 0;
  color: #333333;
  margin-top: 0;
}

.recuperar-rodapé {
  font: normal normal normal 12px/17px Open Sans;
  letter-spacing: 0;
  color: #333333;
  margin-bottom: 15px !important;
}
.answer {
  margin-bottom: 5px;
}
.lineActionButtons{
  display: flex;
  align-items: center;
}
.lineActionButtons div {
  margin: 2px;
}
</style>
